export default {"src":"/_next/static/media/bph.3e4d7ae1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};